import { hookstate } from "@hookstate/core"

import { StateType } from "./types"

export const LocalState = hookstate<StateType>({
  loading: false,
  keyword: "",
  users: []
} satisfies StateType)